import { styled } from 'next-yak';

import { spaceS, xdlColorTextSecondary } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const Container = styled.div`
  align-items: center;
  display: flex;
  gap: ${spaceS};
`;

export const Copy = styled(BodyCopy)`
  && {
    color: ${xdlColorTextSecondary};
  }
`;
